import { render } from "./PortalNegocios.vue?vue&type=template&id=9bf5fcb6&scoped=true"
import script from "./PortalNegocios.vue?vue&type=script&lang=js"
export * from "./PortalNegocios.vue?vue&type=script&lang=js"

import "./PortalNegocios.vue?vue&type=style&index=0&id=9bf5fcb6&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf5fcb6"]])

export default __exports__